import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { styled, ThemeProvider, useTheme, createTheme } from '@mui/material/styles';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Typography": Typography, "@mui/material/Grid": Grid, "@mui/material/Box": Box, "@mui/material/styles": { styled, ThemeProvider, useTheme, createTheme } } } });
export default ClientProvider;
